import { useField } from "formik";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { Switch } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  title: string;
  body: string;
  value: boolean;
  onValueChange: (value: boolean) => void;
};

export default function FormSwitch({
  title,
  body,
  value,
  onValueChange,
}: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row items-center")}>
      <View style={tailwind("flex-1 mr-1")}>
        <Text variant="titleMedium">{title}</Text>
        <Text variant="bodyMedium">{body}</Text>
      </View>

      <Switch value={value} onValueChange={onValueChange} />
    </View>
  );
}

type FormikProps = Pick<Props, "title" | "body"> & { fieldName: string };

export function FormikFormSwitch({ fieldName, title, body }: FormikProps) {
  const [field, meta, helpers] = useField<boolean>(fieldName);

  return (
    <FormSwitch
      title={title}
      body={body}
      value={field.value}
      onValueChange={helpers.setValue}
    />
  );
}
